<template>
  <div v-if="entity">
    <h1>Add employee</h1>
    <FileWorking :file="file" v-if="file" />
    <v-card>
      <v-card-text>
        <strong>Employees for:&#160;</strong>
        <EntityZ :entity="entity" />
      </v-card-text>
    </v-card>
    <v-card v-if="file && employees.length">
      <v-card-title>
        <h3>Existing employee</h3>
      </v-card-title>
      <v-card-text>
        <p>Choose from existing employees</p>
        <v-data-table
          :pagination.sync="pagination"
          :headers="headers"
          :items="employees"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>
                <EntityZ :entity="props.item" />
              </td>
              <td>
                <v-btn @click="addEmployee(props.item)">
                  <v-icon>add</v-icon>Employee
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title>
        <h3>Create a new employee</h3>
      </v-card-title>
      <v-card-text>
        <v-form ref="formEmployee" v-model="valid" lazy-validation>
          <v-select
            label="Title"
            v-model="entityCreate.title"
            :items="titles"
            item-value="id"
            item-text="name"
            outline
          />
          <v-text-field
            label="Forename "
            v-model="entityCreate.forename"
            :rules="valueRules"
            outline
          />
          <v-text-field
            label="Surname "
            v-model="entityCreate.surname"
            :rules="valueRules"
            outline
          />
          <v-text-field
            label="Email "
            v-model="email"
            :rules="emailRules"
            outline
          />
          <v-text-field label="Telephone " v-model="telephone" outline />
          <v-btn @click="saveEmployee"> <v-icon>save</v-icon>Save </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TITLES from "@/graphql/directory/Titles";
import EntityZ from "@/components/link/EntityZ";
import FileWorking from "@/components/link/FileWorking";
import nbmlaw from "@/api/nbmlaw";
import emailValidator from "email-validator";
export default {
  name: "EmployeeAdd",
  metaInfo() {
    return {
      title: "Employee add",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ,
    FileWorking
  },
  apollo: {
    titles: {
      query: TITLES,
      context: { clientName: "open" },
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      entity: null,
      addressBook: null,
      file: null,
      employees: [],
      headers: [
        {
          text: "Employee",
          value: "name"
        },
        {
          text: "Options",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      },
      entityCreate: {
        title: "Mr",
        forename: null,
        surname: null,
        name: null
      },
      email: null,
      telephone: null,
      valueRules: [(v) => !!v || "Value is required"],
      emailRules: [
        (v) => {
          if (!v) {
            return "Email address is required";
          }
          return emailValidator.validate(v) || "Invalid e-mail.";
        }
      ],
      valid: false
    };
  },
  methods: {
    async fetchEntity() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.entity = response.data;
    },
    async fetchAddressBook() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/addressBooks/${this.$route.query.addressbookid}`
      );
      // console.log(response.data);
      this.addressBook = response.data;
    },
    async fetchFile() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/addressBooks/${this.$route.query.addressbookid}/file`
      );
      // console.log(response.data);
      this.file = response.data;
    },
    async fetchEmployees() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/${this.$route.params.id}/employees`,
        {
          params: {
            addressbookid: this.$route.query.addressbookid
          }
        }
      );
      // console.log(response.data);
      this.employees = response.data;
    },
    async addEmployee(employee) {
      if (confirm("Are you sure?")) {
        await nbmlaw.post(
          `/cors/admin/directory/addressBooks/${this.$route.query.addressbookid}/employees`,
          null,
          {
            params: {
              employeeid: employee.id
            }
          }
        );
        // console.log(response.data);
        this.navigate();
      }
    },
    async saveEmployee() {
      if (this.$refs.formEmployee.validate()) {
        await nbmlaw.post(
          `/cors/admin/directory/entities/${this.$route.params.id}/employees`,
          {
            ...this.entityCreate,
            addressbookid: this.$route.query.addressbookid,
            email: this.email,
            telephone: this.telephone
          }
        );
        // console.log(response.data);
        this.navigate();
      }
    },
    navigate() {
      if (this.$route.query.addressbookid) {
        this.$router.push({ name: "file", params: { id: this.file.id } });
      } else {
        this.$router.push({
          name: "entity",
          params: { id: this.$route.params.id }
        });
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchEntity();
      }
    },
    "$route.query.addressbookid": {
      immediate: true,
      handler() {
        if (this.$route.query.addressbookid) {
          this.fetchAddressBook();
          this.fetchFile();
          this.fetchEmployees();
        } else {
          this.addressBook = null;
          this.file = null;
          this.employees = null;
        }
      }
    }
  }
};
</script>

<style>
</style>
